<template>
  <svg
    viewBox="0 0 30 30"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="#4f2b1b">
      <path
        d="m15 30a15 15 0 1 1 13.82-9.16 15 15 0 0 1 -8 8 15 15 0 0 1 -5.82 1.16zm0-28.43a13.38 13.38 0 0 0 -5.23 1.05 13.49 13.49 0 0 0 -7.15 7.15 13.55 13.55 0 0 0 0 10.46 13.49 13.49 0 0 0 7.15 7.15 13.55 13.55 0 0 0 10.46 0 13.49 13.49 0 0 0 7.15-7.15 13.55 13.55 0 0 0 0-10.46 13.49 13.49 0 0 0 -7.15-7.15 13.38 13.38 0 0 0 -5.23-1.05z"
      />
      <path
        d="m6.78 9.39a3.72 3.72 0 0 1 1-2.72 3.62 3.62 0 0 1 2.74-1.07 3.58 3.58 0 0 1 2.71 1.08 3.79 3.79 0 0 1 1 2.78v.9a3.68 3.68 0 0 1 -1 2.71 3.62 3.62 0 0 1 -2.67 1 3.62 3.62 0 0 1 -3.77-3.85zm1.73 1a2.41 2.41 0 0 0 .55 1.61 1.9 1.9 0 0 0 1.49.64 1.85 1.85 0 0 0 1.45-.64 2.49 2.49 0 0 0 .55-1.69v-.93a2.47 2.47 0 0 0 -.55-1.63 1.84 1.84 0 0 0 -1.47-.64 1.84 1.84 0 0 0 -1.47.64 2.53 2.53 0 0 0 -.54 1.68zm2.57 12.44-1.32-.83 8.94-14.35 1.3.83zm4.61-3.1a3.69 3.69 0 0 1 1-2.71 3.63 3.63 0 0 1 2.7-1.07 3.66 3.66 0 0 1 2.75 1.05 3.76 3.76 0 0 1 1.06 2.8v.9a3.69 3.69 0 0 1 -1.05 2.71 3.62 3.62 0 0 1 -2.69 1.06 3.7 3.7 0 0 1 -2.7-1.05 3.75 3.75 0 0 1 -1.07-2.8zm1.74 1a2.37 2.37 0 0 0 .57 1.56 2 2 0 0 0 2.93 0 2.51 2.51 0 0 0 .54-1.7v-.93a2.37 2.37 0 0 0 -.55-1.63 2 2 0 0 0 -2.91 0 2.37 2.37 0 0 0 -.56 1.68z"
      />
    </g>
  </svg>
</template>
